import * as React from 'react'

import Dashboard from '../components/Dashboard'

export default function Index() {
  return <Dashboard />
}
